// extracted by mini-css-extract-plugin
export default {"spinner":"styles__spinner___DXZiO","spin":"styles__spin___96pMK"};